import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { LocalStorageService } from '../local-storage.service';
import { global } from 'app/utils/global';
import { Usuario } from 'app/domain/usuario';
import { Cliente } from 'app/domain/cliente';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private localStorageService: LocalStorageService,
    private router: Router
  ) { }

  /**
   * @author Frank Edward Daza González
   * @version 2018-11-06
   * @param next 
   * @param state 
   */
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const usuario: Usuario = this.authService.getUsuario();
    let cliente;
    let pedido;
    switch (next.data.guards) {
      //Loged in
      case global.GUARDS.NO_AUTH:
        if (!usuario) {
          return true;
        } else {
          this.router.navigate(['/']);
          return false;
        }
      case global.GUARDS.AUTH:
        if (usuario) {
          return true;
        } else {
          this.router.navigate(['/auth/login']);
          return false;
        }

      //Roles
      case global.GUARDS.VENDEDOR:
        if (usuario && usuario.nombreRol == global.GUARDS.VENDEDOR) {
          return true;
        }
        break;
      case global.GUARDS.TELEMERCADERISTA:
        if (usuario && usuario.nombreRol == global.GUARDS.TELEMERCADERISTA) {
          return true;
        }
        if (usuario && (usuario.nombreRol == global.GUARDS.LOGISTICA
          || usuario.nombreRol == global.GUARDS.AUXILIAR_ADMINISTRATIVO_FACTURACION
          || usuario.nombreRol == global.GUARDS.AUXILIAR_FACTURACION_CEDI
          || usuario.nombreRol == global.GUARDS.AUXILIAR_ADMINISTRATIVO_CEDI)) {
          return true;
        }
        if (usuario && usuario.nombreRol == global.GUARDS.VALIDADOR) {
          return true;
        }
        break;
      case global.GUARDS.LOGISTICA:
        if (usuario && (usuario.nombreRol == global.GUARDS.LOGISTICA
          || usuario.nombreRol == global.GUARDS.AUXILIAR_ADMINISTRATIVO_FACTURACION
          || usuario.nombreRol == global.GUARDS.AUXILIAR_FACTURACION_CEDI
          || usuario.nombreRol == global.GUARDS.AUXILIAR_ADMINISTRATIVO_CEDI)) {
          return true;
        }
        break;
      case global.GUARDS.FACTURADOR:
        if (usuario && usuario.nombreRol == global.GUARDS.FACTURADOR) {
          return true;
        }
        break;
      case global.GUARDS.AUTORIZADOR:
        if (usuario && usuario.nombreRol == global.GUARDS.AUTORIZADOR) {
          return true;
        }
        break;
       case global.GUARDS.ADMINISTRADOR:
        if (usuario && usuario.nombreRol == global.GUARDS.ADMINISTRADOR) {
          return true;
        }
        break;
      case global.GUARDS.VALIDADOR:
        if (usuario && usuario.nombreRol == global.GUARDS.VALIDADOR) {
          return true;
        }
        break;

      //Opciones
      case global.GUARDS.CLIENTE:
        cliente = this.localStorageService.get(global.SESSION_ITEMS.CLIENTE);
        if (cliente) {
          return true;
        } else {
          this.router.navigate(['/rutero']);
          return false;
        }
      case global.GUARDS.PEDIDO_FACTURADOR:
        pedido = this.localStorageService.get(global.SESSION_ITEMS.CLIENTE);
        if (pedido) {
          return true;
        } else {
          this.router.navigate(['/facturador']);
          return false;
        }
    }
    this.redirectToHome(usuario ? usuario.nombreRol : null);
    return false;
  }

  redirectToHome(rol) {
    switch (rol) {
      case null:
        this.router.navigate(['/auth/login']);
        break;
      case global.GUARDS.VENDEDOR:
        this.router.navigate(['/tablero']);
        break;
      case global.GUARDS.TELEMERCADERISTA:
        this.router.navigate(['/telemercaderista']);
        break;
      case global.GUARDS.LOGISTICA:
        this.router.navigate(['/ordenRecoleccionNc']);
        break;
      case global.GUARDS.AUXILIAR_ADMINISTRATIVO_FACTURACION:
        this.router.navigate(['/ordenRecoleccionNc']);
        break;
      case global.GUARDS.AUXILIAR_FACTURACION_CEDI:
        this.router.navigate(['/ordenRecoleccionNc']);
        break;
      case global.GUARDS.AUXILIAR_ADMINISTRATIVO_CEDI:
        this.router.navigate(['/ordenRecoleccionNc']);
        break;
      case global.GUARDS.FACTURADOR:
        this.router.navigate(['/facturador']);
        break;
      case global.GUARDS.AUTORIZADOR:
          this.router.navigate(['/autorizador']);
        break;
        case global.GUARDS.ADMINISTRADOR:
          this.router.navigate(['/gestion-autorizador']);
        break;
        case global.GUARDS.VALIDADOR:
          this.router.navigate(['/telemercaderista']);
          break;
      default:
        break;
    }
  }

}
